class API_CLS {

    static common = {
        "settings":"/api/web/client/v1/system/settings",
        "health": "/api/health",
        "get_market_qr_codes":"/api/web/client/v1/user/auth/qr/1",
        "get_build_info":"/assets/build_info.json"
    }
    
    static methods = {
        "Post":"post",
        "Get":"get"
    }
    
    static account = {
        "email_1": "/api/web/client/v1/user/auth/email/1",
        "email_2": "/api/web/client/v1/user/auth/email/2",
        "phone_1": "/api/web/client/v1/user/auth/phone/1",
        "phone_2": "/api/web/client/v1/user/auth/phone/2",
        "check_phone": "/api/web/client/v1/user/auth/check-user-by-phone",
        "set": "/api/web/client/v1/user/auth/passcode/set",
        "auth": "/api/web/client/v1/user/auth/passcode",
        "me": "/api/web/client/v1/user/me",
        "logout": "/api/web/client/v1/user/auth/logout",
        "reset_pwd_by_email1": "/api/web/client/v1/user/auth/passcode/reset/email/1",
        "reset_pwd_by_email2": "/api/web/client/v1/user/auth/passcode/reset/email/2",
        "reset_pwd_by_phone1": "/api/web/client/v1/user/auth/passcode/reset/phone/1",
        "reset_pwd_by_phone2": "/api/web/client/v1/user/auth/passcode/reset/phone/2",
        "public_reset_pwd_by_email1": "/api/web/client/v1/user/auth/passcode/public-reset/email/1",
        "public_reset_pwd_by_email2": "/api/web/client/v1/user/auth/passcode/public-reset/email/2",
        "public_reset_pwd_by_phone1": "/api/web/client/v1/user/auth/passcode/public-reset/phone/1",
        "public_reset_pwd_by_phone2": "/api/web/client/v1/user/auth/passcode/public-reset/phone/2",
        "mpass_individ": "/api/web/client/v1/user/auth/mpass/login/individual",
        "mpass_company": "/api/web/client/v1/user/auth/mpass/login/company",
        "edit_profile": {
            "email1": "/api/web/client/v1/user/auth/email/set/1",
            "email2": "/api/web/client/v1/user/auth/email/set/2",
            "phone1": "/api/web/client/v1/user/auth/phone/set/1",
            "phone2": "/api/web/client/v1/user/auth/phone/set/2"
        },
        "user_update": "/api/web/client/v1/user/update"
    }

    static loans = {
        "pre_apply": "/api/web/client/v1/loan/request/apply-loan",
        "uncommited": "/api/web/client/v1/loan/request/uncommited",
        "loan_list": "/api/web/client/v1/loan/active",
        "cr_line_loan_list": "/api/web/client/v1/loan/credit_line",
        "loan_request_individual": "/api/web/client/v1/loan/request/individual",
        "pending_loans": "/api/web/client/v1/loan/pending-list",
        "contract": {
            "get_contract": "/api/web/client/v1/loan/contract",
            "read_contract": "/api/web/client/v1/loan/read-contract",
            "send_contract": "/api/web/client/v1/loan/send-contract",
            "sign_contract1": "/api/web/client/v1/loan/contract/sign/1",
            "sign_contract2": "/api/web/client/v1/loan/contract/sign/2",
            
            "get_transaction_contract": "/api/web/client/v1/loan/transaction-contract",
            "read_transaction_contract": "/api/web/client/v1/loan/read-transaction-contract",
            "sign_transaction_contract1": "/api/web/client/v1/loan/transaction-contract/sign/1",
            "sign_transaction_contract2": "/api/web/client/v1/loan/transaction-contract/sign/2",
        },
        "get_schedule":"/api/web/client/v1/loan/schedule-payments",
        "get_methods": "/api/web/client/v1/loan/payment-methods",
        "credit_line_transaction":"/api/web/client/v1/loan/credit-line/transaction"
    }

    static payments = {
        "invoice":"https://pay.ecredit.md/api/v1/paynet/oplata/easycredit/invoice",
    }

    static kyc = {
        "face_liveness_start": "/api/web/client/v1/user/kyc/face/liveness/transaction/start",
        "face_liveness_finish": "/api/web/client/v1/user/kyc/face/liveness/transaction/finish"
    }
    
    static calculator = {
        "get_limits": "/api/web/client/v1/user/product/get/limits",
        "get_products": "/api/web/client/v1/user/product/get/products",
    }
    
    static notifications = {
        "get_per_pages":"/api/web/client/v1/notification/get",
        "read_all": "/api/web/client/v1/notification/read-all",
        "read": "/api/web/client/v1/notification/read",
        "delete": "/api/web/client/v1/notification/delete",
        "generate": "/api/web/client/v1/notification/test",
        "get_counter": "/api/web/client/v1/notification/count",
        "notif_register": "/api/web/client/v1/device/register",
        "get_technical": "/api/web/client/v1/notification/get/technical",
    }
}

export default API_CLS